import http from '../../../utils/fetch';
import updownfile from '../../../utils/updownfile';
export default {

    baseurl:'/api/swyl/v1/vw/vwcompetitors',

    getCompetitorsByTimePage(q){
        return http({
            url: this.baseurl + '/getCompetitorsByTimePage',
            method: 'post',
            params: q
        });
    },

    getCompetitorsForExcel(userName,category,exfactoryDate,exid){

        updownfile.down(this.baseurl+'/getCompetitorsForExcel',{userName:userName,category:category,exfactoryDate:exfactoryDate,exid:exid},"get");

        // window.location.href =process.env.VUE_APP_AJAXURL + this.baseurl + '/getCompetitorsForExcel?userName='+userName+'&category='+category+'&exfactoryDate='+exfactoryDate+'&exid='+exid

    },





}
